export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  status: '连载中' | '已完结';
  views: number;
  chapters: ComicChapter[];
  createdAt: string;
  updatedAt: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-movie-line' },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line' },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '某天成为公主',
    author: 'PLUTO / SPOON',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20cover%20art%20featuring%20a%20princess%20with%20flowing%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20elegant%20pink%20gown%20in%20a%20royal%20palace%20setting%20with%20soft%20warm%20lighting%20romantic%20fantasy%20aesthetic&width=600&height=800&seq=comic-01&orientation=portrait',
    description: '某天醒来，我发现自己变成了小说中的公主——一个注定要在18岁被自己父亲处死的悲惨角色。为了改变命运，我决定主动接近那位冷酷的皇帝父亲。然而事情的发展却出乎所有人的预料……一段关于亲情、成长与救赎的宫廷奇幻故事就此展开。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '宫廷', '转生'],
    rating: 9.5,
    status: '连载中',
    views: 1280000,
    chapters: [
      { id: '1-1', title: '第1话 序章', number: 1, updatedAt: '2026-01-15' },
      { id: '1-2', title: '第2话 陌生的世界', number: 2, updatedAt: '2026-01-22' },
      { id: '1-3', title: '第3话 第一次见面', number: 3, updatedAt: '2026-01-29' },
      { id: '1-4', title: '第4话 父皇的冷漠', number: 4, updatedAt: '2026-02-05' },
      { id: '1-5', title: '第5话 小小的改变', number: 5, updatedAt: '2026-02-12' },
      { id: '1-6', title: '第6话 花园邂逅', number: 6, updatedAt: '2026-02-19' },
      { id: '1-7', title: '第7话 晚宴风波', number: 7, updatedAt: '2026-02-26' },
      { id: '1-8', title: '第8话 公主的请求', number: 8, updatedAt: '2026-03-05' },
    ],
    createdAt: '2026-01-10',
    updatedAt: '2026-08-01',
  },
  {
    id: '2',
    title: '我独自升级',
    author: 'Chugong / Dubu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Korean%20webtoon%20cover%20art%20featuring%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20purple%20eyes%20surrounded%20by%20shadow%20soldiers%20in%20a%20dungeon%20setting%20dramatic%20lighting%20action%20fantasy%20aesthetic&width=600&height=800&seq=comic-02&orientation=portrait',
    description: '十年前，世界各地出现了连接异次元的「门」，而其中少部分人觉醒了特殊能力成为「猎人」。成振宇是被称为「人类最弱兵器」的E级猎人，在一次几乎全军覆没的双重地下城任务中，他获得了神秘的系统——「玩家」资格。从此，他成为了唯一能够「升级」的猎人。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '奇幻', '升级', '系统'],
    rating: 9.8,
    status: '已完结',
    views: 3560000,
    chapters: [
      { id: '2-1', title: '第1话 最弱猎人', number: 1, updatedAt: '2025-06-01' },
      { id: '2-2', title: '第2话 双重地下城', number: 2, updatedAt: '2025-06-08' },
      { id: '2-3', title: '第3话 生死抉择', number: 3, updatedAt: '2025-06-15' },
      { id: '2-4', title: '第4话 系统激活', number: 4, updatedAt: '2025-06-22' },
      { id: '2-5', title: '第5话 每日任务', number: 5, updatedAt: '2025-06-29' },
    ],
    createdAt: '2025-06-01',
    updatedAt: '2026-07-15',
  },
  {
    id: '3',
    title: '女神降临',
    author: 'Yaongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20webtoon%20cover%20art%20featuring%20a%20beautiful%20young%20woman%20with%20perfect%20makeup%20and%20long%20brown%20hair%20in%20a%20school%20uniform%20surrounded%20by%20cosmetics%20and%20beauty%20products%20bright%20colorful%20romantic%20comedy%20aesthetic&width=600&height=800&seq=comic-03&orientation=portrait',
    description: '因为外貌被欺负的林周京，通过化妆技巧实现了惊人蜕变，转学后成为了校园女神。但她一直隐藏着自己素颜的秘密。直到那个看穿一切的男人——李修豪出现。一段关于自信、成长与真爱的校园故事，探讨什么才是真正的美丽。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '美妆', '成长'],
    rating: 9.3,
    status: '已完结',
    views: 2890000,
    chapters: [
      { id: '3-1', title: '第1话 自卑的女孩', number: 1, updatedAt: '2025-08-10' },
      { id: '3-2', title: '第2话 化妆的力量', number: 2, updatedAt: '2025-08-17' },
      { id: '3-3', title: '第3话 转学第一天', number: 3, updatedAt: '2025-08-24' },
      { id: '3-4', title: '第4话 男神的注视', number: 4, updatedAt: '2025-08-31' },
    ],
    createdAt: '2025-08-10',
    updatedAt: '2026-06-20',
  },
  {
    id: '4',
    title: '伯爵家的废物',
    author: 'Yoo Ryeo Han / PAN4',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20art%20featuring%20a%20young%20nobleman%20with%20silver%20hair%20and%20red%20eyes%20in%20an%20elegant%20dark%20suit%20holding%20a%20magical%20orb%20gothic%20mansion%20background%20mysterious%20fantasy%20noble%20aesthetic&width=600&height=800&seq=comic-04&orientation=portrait',
    description: '凯尔·海尼图斯穿越到了自己读过的小说中，成为了一个注定要被主角暴打的纨绔子弟。为了避免悲惨结局，他决定低调做人、远离麻烦。但不知道为什么，麻烦总是主动找上门来。一个只想躺平的穿越者和一群不让他躺平的人们的故事。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '穿越', '搞笑', '贵族'],
    rating: 9.4,
    status: '连载中',
    views: 1870000,
    chapters: [
      { id: '4-1', title: '第1话 异世界', number: 1, updatedAt: '2025-09-05' },
      { id: '4-2', title: '第2话 我想躺平', number: 2, updatedAt: '2025-09-12' },
      { id: '4-3', title: '第3话 麻烦来了', number: 3, updatedAt: '2025-09-19' },
    ],
    createdAt: '2025-09-05',
    updatedAt: '2026-08-02',
  },
  {
    id: '5',
    title: '恶女是提线木偶',
    author: 'Manggle / Hanirim',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20cover%20art%20featuring%20an%20elegant%20villainess%20woman%20with%20dark%20hair%20and%20piercing%20eyes%20in%20a%20luxurious%20red%20dress%20holding%20a%20fan%20with%20puppet%20strings%20in%20background%20royal%20palace%20dark%20romance%20aesthetic&width=600&height=800&seq=comic-05&orientation=portrait',
    description: '凯琳娜是帝国最美丽的女人，也是最令人畏惧的恶女。没有人知道，她只是一个被操纵的提线木偶。当她意识到自己的命运后，决定挣脱控制，反过来利用一切资源掌控自己的人生。一场华丽的复仇与权力游戏即将上演。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '宫廷', '复仇', '女性向'],
    rating: 9.2,
    status: '连载中',
    views: 980000,
    chapters: [
      { id: '5-1', title: '第1话 帝国之花', number: 1, updatedAt: '2026-02-10' },
      { id: '5-2', title: '第2话 提线木偶', number: 2, updatedAt: '2026-02-17' },
      { id: '5-3', title: '第3话 觉醒', number: 3, updatedAt: '2026-02-24' },
      { id: '5-4', title: '第4话 新的棋局', number: 4, updatedAt: '2026-03-03' },
    ],
    createdAt: '2026-02-10',
    updatedAt: '2026-07-28',
  },
  {
    id: '6',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20webtoon%20cover%20art%20featuring%20an%20ordinary%20office%20worker%20man%20with%20glasses%20transformed%20into%20a%20survivor%20in%20a%20post-apocalyptic%20world%20surrounded%20by%20monsters%20and%20scenario%20text%20boxes%20dramatic%20action%20survival%20aesthetic&width=600&height=800&seq=comic-06&orientation=portrait',
    description: '金独子是唯一读完了一部连载了3149话的冷门末世小说的读者。就在小说完结的那一天，小说中的世界突然变成了现实。作为唯一知道整个故事走向的人，他必须利用自己的「全知」优势在这场末日游戏中生存下去。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '末世', '系统', '生存'],
    rating: 9.7,
    status: '连载中',
    views: 2450000,
    chapters: [
      { id: '6-1', title: '第1话 最后的读者', number: 1, updatedAt: '2026-01-20' },
      { id: '6-2', title: '第2话 世界变了', number: 2, updatedAt: '2026-01-27' },
      { id: '6-3', title: '第3话 第一个剧本', number: 3, updatedAt: '2026-02-03' },
      { id: '6-4', title: '第4话 同伴', number: 4, updatedAt: '2026-02-10' },
      { id: '6-5', title: '第5话 车站之战', number: 5, updatedAt: '2026-02-17' },
      { id: '6-6', title: '第6话 主角登场', number: 6, updatedAt: '2026-02-24' },
    ],
    createdAt: '2026-01-20',
    updatedAt: '2026-08-03',
  },
  {
    id: '7',
    title: '她的私生活',
    author: 'Kim Sung Yeon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20webtoon%20cover%20art%20featuring%20a%20professional%20woman%20with%20short%20hair%20in%20an%20art%20gallery%20uniform%20secretly%20holding%20a%20fan%20merchandise%20behind%20her%20back%20duality%20concept%20warm%20romantic%20comedy%20aesthetic&width=600&height=800&seq=comic-07&orientation=portrait',
    description: '成德美是美术馆的首席策展人，外表是冷酷的职场精英。但她的另一个身份是追星十年的资深站姐。当新馆长莱恩·戈尔德上任后，她的双重生活开始面临前所未有的挑战。一部关于追星、职场与爱情的故事。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '职场', '追星', '搞笑'],
    rating: 9.1,
    status: '已完结',
    views: 1560000,
    chapters: [
      { id: '7-1', title: '第1话 完美的策展人', number: 1, updatedAt: '2025-10-10' },
      { id: '7-2', title: '第2话 新馆长', number: 2, updatedAt: '2025-10-17' },
      { id: '7-3', title: '第3话 差点暴露', number: 3, updatedAt: '2025-10-24' },
    ],
    createdAt: '2025-10-10',
    updatedAt: '2026-05-10',
  },
  {
    id: '8',
    title: '鬼灭之刃（韩译版）',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20style%20webtoon%20cover%20art%20featuring%20a%20young%20swordsman%20with%20dark%20red%20hair%20and%20a%20green%20checkered%20haori%20coat%20holding%20a%20katana%20with%20water%20dragon%20effect%20traditional%20Japanese%20setting%20fused%20with%20Korean%20manhwa%20art%20style&width=600&height=800&seq=comic-08&orientation=portrait',
    description: '大正时代的日本，少年灶门炭治郎一家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类之身，炭治郎踏上了成为鬼杀队剑士的旅程。韩国翻译版本，保留了原作精美的画面和热血的情节。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '热血', '少年', '奇幻'],
    rating: 9.6,
    status: '已完结',
    views: 4200000,
    chapters: [
      { id: '8-1', title: '第1话 残酷', number: 1, updatedAt: '2024-03-01' },
      { id: '8-2', title: '第2话 培育者', number: 2, updatedAt: '2024-03-08' },
      { id: '8-3', title: '第3话 最终选拔', number: 3, updatedAt: '2024-03-15' },
    ],
    createdAt: '2024-03-01',
    updatedAt: '2026-03-15',
  },
  {
    id: '9',
    title: '入室妖谈',
    author: 'MIAS',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20cover%20art%20featuring%20a%20young%20woman%20with%20long%20black%20hair%20peeking%20through%20a%20slightly%20open%20door%20with%20a%20shadowy%20figure%20behind%20her%20creepy%20supernatural%20horror%20thriller%20aesthetic&width=600&height=800&seq=comic-09&orientation=portrait',
    description: '独居的女性上班族每晚都会听到奇怪的声音。某天她发现，自己的房间里似乎住着什么东西……一部让人脊背发凉的都市怪谈系悬疑漫画。每一扇门背后都可能藏着未知的恐惧。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '恐怖', '都市传说', '惊悚'],
    rating: 8.9,
    status: '连载中',
    views: 720000,
    chapters: [
      { id: '9-1', title: '第1话 奇怪的声音', number: 1, updatedAt: '2026-04-05' },
      { id: '9-2', title: '第2话 门缝', number: 2, updatedAt: '2026-04-12' },
      { id: '9-3', title: '第3话 邻居', number: 3, updatedAt: '2026-04-19' },
    ],
    createdAt: '2026-04-05',
    updatedAt: '2026-07-20',
  },
  {
    id: '10',
    title: '梨泰院Class',
    author: 'Gwang Jin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20webtoon%20cover%20art%20featuring%20a%20determined%20young%20man%20with%20a%20unique%20hairstyle%20standing%20in%20front%20of%20a%20trendy%20restaurant%20and%20bar%20in%20Itaewon%20neon%20signs%20nightlife%20urban%20drama%20aesthetic&width=600&height=800&seq=comic-10&orientation=portrait',
    description: '朴世路因为痛打财阀二代而入狱，出狱后在梨泰院开设了一家小酒馆，开始了他的商业复仇之路。面对不公的世界，他坚守信念，一步步向着目标前进。一部关于梦想、坚持与正义的励志故事。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '励志', '复仇', '都市'],
    rating: 9.4,
    status: '已完结',
    views: 3100000,
    chapters: [
      { id: '10-1', title: '第1话 那一天', number: 1, updatedAt: '2025-01-05' },
      { id: '10-2', title: '第2话 决心', number: 2, updatedAt: '2025-01-12' },
      { id: '10-3', title: '第3话 梨泰院', number: 3, updatedAt: '2025-01-19' },
      { id: '10-4', title: '第4话 甜夜', number: 4, updatedAt: '2025-01-26' },
    ],
    createdAt: '2025-01-05',
    updatedAt: '2026-04-20',
  },
  {
    id: '11',
    title: '大贵族',
    author: 'Son Jeho / Lee Kwangsu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20webtoon%20cover%20art%20featuring%20a%20handsome%20vampire%20noble%20with%20silver%20hair%20and%20red%20eyes%20in%20a%20modern%20school%20uniform%20standing%20in%20front%20of%20a%20grand%20castle%20supernatural%20action%20noble%20vampire%20aesthetic&width=600&height=800&seq=comic-11&orientation=portrait',
    description: '卡迪斯·艾特拉马·迪·莱杰罗，是一名沉睡了820年的贵族（吸血鬼）。醒来后的他进入现代高中，成为了一名普通学生。然而他的身份和力量注定无法让他过上平静的生活。守护与背叛，忠诚与友情。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '吸血鬼', '校园', '战斗'],
    rating: 9.3,
    status: '已完结',
    views: 2700000,
    chapters: [
      { id: '11-1', title: '第1话 觉醒', number: 1, updatedAt: '2024-06-10' },
      { id: '11-2', title: '第2话 学校', number: 2, updatedAt: '2024-06-17' },
      { id: '11-3', title: '第3话 仆人', number: 3, updatedAt: '2024-06-24' },
    ],
    createdAt: '2024-06-10',
    updatedAt: '2025-12-25',
  },
  {
    id: '12',
    title: '外貌至上主义',
    author: 'Park Tae Jun',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20art%20featuring%20a%20transformation%20concept%20showing%20an%20overweight%20high%20school%20student%20and%20his%20ideal%20handsome%20version%20side%20by%20side%20with%20a%20mirror%20effect%20school%20bullying%20social%20commentary%20drama%20aesthetic&width=600&height=800&seq=comic-12&orientation=portrait',
    description: '朴亨硕是一个因为肥胖和贫穷而遭受校园霸凌的高中生。转学后，他意外发现自己在睡觉时可以切换到一个完美的帅气身体。双重身份的生活让他看到了世界的两面性——外貌真的能决定一个人的命运吗？',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '校园', '社会', '成长'],
    rating: 9.0,
    status: '连载中',
    views: 2100000,
    chapters: [
      { id: '12-1', title: '第1话 转学', number: 1, updatedAt: '2025-11-15' },
      { id: '12-2', title: '第2话 两个身体', number: 2, updatedAt: '2025-11-22' },
      { id: '12-3', title: '第3话 新世界', number: 3, updatedAt: '2025-11-29' },
    ],
    createdAt: '2025-11-15',
    updatedAt: '2026-07-10',
  },
];

export const featuredComicIds = ['1', '2', '6', '4'];

export const latestComicIds = ['5', '9', '12', '3', '8', '10', '11', '7'];

export const popularComicIds = ['2', '6', '8', '1', '10', '3'];